// extracted by mini-css-extract-plugin
export var alignCenter = "_by-d";
export var bannerShown = "_by-6";
export var buttonContent = "_by-0";
export var cardList = "_by-1";
export var centerContent = "_by-2";
export var chevron = "_by-3";
export var closePanelButton = "_by-k";
export var conversationContextContainer = "_by-l";
export var conversationDetailContainer = "_by-4";
export var detailWrapper = "_by-7";
export var dropdownButton = "_by-e";
export var dropdownTitle = "_by-9";
export var fullHeight = "_by-5";
export var hidden = "_by-a";
export var icon = "_by-b";
export var mergeSuggestionWrapper = "_by-m";
export var panel = "_by-i";
export var portalButtonsWrapper = "_by-c";
export var right = "_by-j";
export var tableSummaryContainer = "_by-8";
export var tableSummaryHeader = "_by-g";
export var threeDotsButton = "_by-f";
export var wide = "_by-h";